(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fp-notify"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORE_KEY = 'fp-notify';
    const dialog = document.querySelector('[data-fp-notify-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const form = dialog.querySelector('form');
    const tagsInput = dialog.querySelector('[data-fp-notify-tags]');
    const nameInput = dialog.querySelector('[data-fp-notify-name]');
    const firstNameInput = dialog.querySelector('[data-fp-notify-first-name]');
    const lastNameInput = dialog.querySelector('[data-fp-notify-last-name]');
    const errorNote = dialog.querySelector('[data-fp-notify-error]');
    const prefix = dialog.dataset.tagPrefix || 'notify';

    const handleize = (text) =>
      String(text || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const read = () => {
      try {
        return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      } catch (error) {
        return null;
      }
    };

    const write = (value) => {
      try {
        if (value) sessionStorage.setItem(STORE_KEY, JSON.stringify(value));
        else sessionStorage.removeItem(STORE_KEY);
      } catch (error) {
        /* private mode: the sign-up still works, the popup just will not reopen */
      }
    };

    /** The request the popup is currently showing: { title, tags }. */
    let current = { title: '', tags: prefix };

    const show = (state, request) => {
      current = request || current;
      dialog.querySelectorAll('[data-fp-notify-product]').forEach((slot) => {
        slot.textContent = current.title;
      });
      if (tagsInput) tagsInput.value = current.tags;
      dialog.querySelectorAll('[data-fp-notify-state]').forEach((panel) => {
        panel.hidden = panel.dataset.fpNotifyState !== (state === 'success' ? 'success' : 'form');
      });
      if (errorNote) errorNote.hidden = state !== 'error';
      if (!dialog.open) dialog.showModal();
    };

    const requestFrom = (button) => {
      const title = button.dataset.productTitle || '';
      const handle = button.dataset.productHandle || handleize(title);
      const variant = button.dataset.variantTitle || '';
      const tags = [`${prefix}-${handle}`];
      if (variant) tags.push(`${prefix}-${handle}-${handleize(variant)}`);
      return { title, tags: tags.join(', ') };
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const opener = target.closest('[data-fp-notify]');
      if (opener instanceof HTMLElement) {
        event.preventDefault();
        show('form', requestFrom(opener));
        return;
      }

      if (target.closest('[data-fp-notify-close]')) {
        dialog.close();
        return;
      }

      // A click on the dimmed backdrop lands on the dialog element, outside its box.
      if (target === dialog) {
        const box = dialog.getBoundingClientRect();
        const inside =
          event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
        if (!inside) dialog.close();
      }
    });

    if (form) {
      form.addEventListener('submit', () => {
        // One "Name" box on screen; Shopify stores first and last name separately. The
        // box has no name of its own and is left as typed: the hidden fields carry it.
        if (nameInput && firstNameInput && lastNameInput) {
          const parts = nameInput.value.trim().split(/\s+/);
          firstNameInput.value = parts[0];
          lastNameInput.value = parts.slice(1).join(' ');
        }
        write(current);
      });
    }

    // Back from the form post: reopen on the result, but only if this popup sent it.
    const pending = read();
    const result = dialog.querySelector('[data-fp-notify-result]');
    if (pending && result instanceof HTMLElement) {
      write(null);
      document.querySelectorAll('.fp-footer__form-note').forEach((note) => note.remove());
      show(result.dataset.fpNotifyResult === 'success' ? 'success' : 'error', pending);
      const url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('contact_posted');
      history.replaceState(history.state, '', url.pathname + url.search);
    } else if (pending) {
      write(null);
    }

    /* Product page: show the notify button only while the chosen model is unavailable. */
    const syncCta = (cta) => {
      const data = cta.querySelector('[data-fp-notify-variants]');
      const scope = cta.closest('.shopify-section') || document;
      if (!data) return;

      let variants = [];
      try {
        variants = JSON.parse(data.textContent || '[]');
      } catch (error) {
        return;
      }

      const chosen = [];
      scope.querySelectorAll('variant-picker fieldset, variant-picker select').forEach((group) => {
        if (group instanceof HTMLSelectElement) {
          chosen.push(group.value);
          return;
        }
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked instanceof HTMLInputElement) chosen.push(checked.value);
      });
      if (chosen.length === 0) return;

      const variant = variants.find(
        (item) => item.options.length === chosen.length && item.options.every((value, index) => value === chosen[index])
      );
      if (!variant) return;

      cta.hidden = variant.available;
      cta.querySelectorAll('[data-fp-notify]').forEach((button) => {
        if (button instanceof HTMLElement) button.dataset.variantTitle = variants.length > 1 ? variant.title : '';
      });
    };

    /* Phones: stick the notify bar to the bottom once the button itself is off screen. */
    if ('IntersectionObserver' in window) {
      document.querySelectorAll('[data-fp-notify-cta]').forEach((cta) => {
        const inline = cta.querySelector('.fp-notify-cta__button');
        const bar = cta.querySelector('[data-fp-notify-bar]');
        if (!inline || !(bar instanceof HTMLElement)) return;
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            bar.dataset.stuck = String(!entry.isIntersecting);
          });
        }).observe(inline);
      });
    }

    document.addEventListener('change', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const picker = target && target.closest('variant-picker');
      if (!picker) return;
      const scope = picker.closest('.shopify-section') || document;
      scope.querySelectorAll('[data-fp-notify-cta]').forEach((cta) => syncCta(cta));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
